import { render } from "./ProjectsListComponent.vue?vue&type=template&id=4f3ac9e8"
import script from "./ProjectsListComponent.vue?vue&type=script&lang=js"
export * from "./ProjectsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__